import { useQueryClient } from '@tanstack/react-query';

import { importClientsFromCsv } from '@/modules/onboarding/clients-setup/api/clients';
import { getErrorClientsColumns } from '@/modules/onboarding/clients-setup/components/import-clients-modal/error-clients-import-columns';
import { ImportEntitiesModal } from '@/modules/onboarding/common/import-entities-modal/import-entities-modal';
import {
  invalidateOnboardingClientValidationReport,
  invalidateOnboardingProjectQueries,
} from '@/modules/onboarding/common/utils/onboarding-query-invalidation';

export function ImportOnboardingClientsModal({
  onSuccess,
}: {
  onSuccess?: (addedCount: number) => void;
}) {
  const queryClient = useQueryClient();

  return (
    <ImportEntitiesModal
      entityRelatedProps={{
        templateLinkHref: '/templates/clients-template.csv',
        templateLinkLabel: 'clients-template.csv',
        importEntitiesFromCsv: async (file: File) => {
          const result = await importClientsFromCsv(file);
          return result.importErrors ?? [];
        },
        onSuccess: async addedCount => {
          await invalidateOnboardingClientValidationReport(queryClient);
          await invalidateOnboardingProjectQueries(queryClient);
          onSuccess?.(addedCount);
        },
        res: {
          addedSuccessfully: 'authenticated.onboarding.clients:importClients.addedSuccessfully',
          title: 'authenticated.onboarding.clients:importClients.title',
          failedImport: 'authenticated.onboarding.clients:importClients.failedImport',
          successImport: 'authenticated.onboarding.clients:importClients.successImport',
          step1Description: 'authenticated.onboarding.clients:importClients.step1Description',
          step2Description: 'authenticated.onboarding.clients:importClients.step2Description',
          backToImport: 'authenticated.onboarding.clients:importClients.backToImport',
        },
      }}
      getErrorEntitiesColumns={getErrorClientsColumns}
      importStringResource={'authenticated.onboarding.clients:import'}
    />
  );
}
